export enum LAYOUT_STATE {
    PHONE_NUMBER,
    PROJECT_LIST,
    SINGLE_PROJECT,
};